import React, { useEffect, useState } from "react";
import { api_url, titleDescription } from "../../config/Config";
import { Table } from "react-bootstrap";
import _fetch from "../../config/api";
import dateFormat from "dateformat";
import ReactPaginate from "react-paginate";
import { ColorRing } from "react-loader-spinner";
import { useTranslation } from 'react-i18next';

const DepositHistory = (props: any) => {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    document.title = `${props.pageTitle} | ${titleDescription}`;
  });

  const [loading, setLoading] = useState(true);
  const [page, setpage] = useState(1);
  const [depositHistory, setDepositHistory] = useState([]);
  const [totalRecord, setTotalRecord] = useState(0);
  const [keyCount, setKeycount] = useState(0);
  const [limit, setLimit] = useState(100);

  useEffect(() => {
    getAllIncomeReport();
  }, [page, totalRecord, limit]);

  const getAllIncomeReport = async () => {
    setLoading(true);
    let res = await _fetch(`${api_url}report/crypto-deposit-history?limit=${limit}&page=${page}`, "GET", {});

    if (res?.status === "success") {
      setLoading(false);
      setDepositHistory(res?.data);
      setTotalRecord(res?.total);
    }
    if (page > 1) {
      setKeycount(0);
      var count = page - 1;
      setKeycount(count * limit);
    }
  }

  const handlePageClick = async (event: any) => {
    const newOffset = (event.selected + 1);
    setpage(newOffset);
  };
  return (
    <main>
      <div className="uni-level-outer">
        <div className="coustom_container">
          <div className="level_inner loader_main">
            {loading &&
              <div className="spinner_bg">
                <div className="color_ring">  <ColorRing
                  visible={true}
                  height="80"
                  width="80"

                  ariaLabel="blocks-loading"
                  wrapperStyle={{}}
                  wrapperClass="blocks-wrapper"
                  colors={['#2b3892', '#2b3892', '#2b3892', '#2b3892', '#2b3892']}
                /></div>

              </div>
            }
            <div className="top_section_unilevel cash_flow">
              <h4>{t("DEPOSIT HISTORY")}</h4>
              <div className="led-selected">
                <form className="ledger-form">

                  {/* <select className="form-control ledger" onChange={(e: any) => { setIncomeChange(e.target.value); setpage(1) }}>
                    <option value="">All</option>
                    <option value="direct_income">{t("Direct Income")}</option>
                    <option value="level_income">{t("Level Income")}</option>
                    <option value="withdraw">{t("Withdraw")}</option>

                  </select> */}

                </form>
              </div>
            </div>
            <div className="table_section">
              <div className="scrolling_table">
                <div className="scroll_under">
                  <Table className="support_table">
                    <thead>
                      <tr className="table_heading_row">
                        <th className="table_heading">#</th>
                        <th className="table_heading">{t("Amount")}</th>
                        <th className="table_heading">{t("Hash")}</th>
                        <th className="table_heading">{t("From")}</th>
                        <th className="table_heading">{t("Date")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {depositHistory?.map((item: any, index: any) => {
                        return (
                          <>
                            <tr className="table_data_row">
                              <td className="table_data"> {page > 1 ? index + keyCount + 1 : index + 1} </td>
                              <td className="table_data">${item?.amount?.toFixed(2)}</td>
                              <td className="table_data"> <a href={`https://bscscan.com/tx/${item.hash}`} target="_blank" >{item?.hash} </a></td>
                              <td className="table_data"> {item?.from} </td>
                              <td className="table_data"> <div className="pic_text">{dateFormat(item?.created_at, "dd-mm-yyyy hh:MM:ss TT")}</div> </td>
                            </tr>
                          </>
                        )
                      })}
                    </tbody>
                  </Table>
                  {totalRecord > 100 && <ReactPaginate className="pagination__2 " activeClassName="active"
                    breakLabel="..."
                    nextLabel=">"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={1}
                    pageCount={totalRecord / 100}
                    previousLabel="<"
                  />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default DepositHistory;
